<template>
  <div class="gameplan">
    <div class="normal_box">
      <el-form :inline="true" ref="editFormRef" :rules="editRules" :model="params" label-position="left" label-width="176px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否需要场勘" prop="needVerify">
              <el-radio-group class="item" v-model="params.needVerify">
                <el-radio v-for="item of radioList" :key="item.key" :label="item.value">{{item.key}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要搭建" prop="needConstruct">
              <el-radio-group class="item" v-model="params.needConstruct" @change="onNeedConstructChanged">
                <el-radio v-for="item of radioList" :key="item.key" :label="item.value">{{item.key}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要SPR" prop="needSpr">
              <el-radio-group class="item" v-model="params.needSpr">
                <el-radio
                  v-for="item of radioList"
                  :key="item.key"
                  :label="item.value"
                  >{{ item.key }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要转场" prop="needSpr">
              <el-radio-group class="item" v-model="params.needTransitions" @change="needTransitionsChanged">
                <el-radio
                  v-for="item of radioList"
                  :key="item.key"
                  :label="item.value"
                  >{{ item.key }}</el-radio
                >
              </el-radio-group>
              <!-- <div v-else >{{ this.params.needTransitions===0?'否':'是' }}</div> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="是否需要督导打卡" prop="needSupervisor">
              <el-radio-group class="item" v-model="params.needSupervisor">
                <el-radio
                  v-for="item of radioList"
                  :key="item.key"
                  :label="item.value"
                  >{{ item.key }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-col :span="24" v-if="showDecorates.length>0">
          <el-form-item v-if="secondTabItemName" label="装饰点位">
            <el-checkbox-group v-model="params.themeDecorateCodes" class="decorate-style">
              <div v-for="item of themeConfig.showDecorates" :class="item.mandatory?'sp':''" :key="item.decorateCode">
                <el-checkbox  :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="secondTabItemName===''" class="cross-item" label="装饰点位">
            <el-checkbox-group v-model="params.themeDecorateCodes" class="decorate-style">
              <div v-for="item of showDecorates" :key="item.decorateCode" :class="item.mandatory?'sp':''">
                <el-checkbox :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label-width="180px">
            <div class="infoBox_cross_line_box">售点参与条件<div class="infoBox_cross_line"></div></div>
          </el-form-item>
        </el-col>
        <el-form-item label="提报售点要求">{{ pocRelateTypeDesc }}</el-form-item>
        <el-form-item v-if="themeConfig.pocRelateType===2" class="cross-item input-width-sp" label="最少关联售点设置" prop="pocCountMin">
          <el-input class="item" type="number" :min="1" v-model="params.pocCountMin" placeholder="请输入售点数量"></el-input>
        </el-form-item>

        <!-- <div v-if="themeConfig.pocRelateType === 1 || themeConfig.pocRelateType === 2">
          <el-form-item class="ignite_item_select" label-width="180px" prop="title" v-model="params.title" label="IGNITE查询规则配置" />
          <div class="sp-el-form-ignite">
            <ConfigDetailIgnite v-for="(item,index) of igniteList" :key="item.itemKey" :index="index" :itemKey="item.itemKey" :baseConfig="baseConfig" :cityPoolList="cityPoolListValid"
              @handleConnect="handleIgniteConnect" :levelIndex="levelIndex" @handleSelectIgnite="handleSelectIgnite" @handleDeleteIgnite="handleDeleteIgnite" :saveInfo="item.saveInfo" @handleBUIgniteConnect="handleBUIgniteConnect"
            />
            <div class="operate-style" @click="addIgniteCount()" v-if="!isRegion">+ 添加售点规则限制</div>
          </div>
        </div> -->
        <div class="sp_form_box" v-if="themeConfig.pocRelateType === 1 || themeConfig.pocRelateType === 2">
          <div class="sp_item_title">
            <div><span style="color:red">* </span>IGNITE查询规则配置</div>
            <!-- <div class="ignite-form-tip">（规则可多选）</div> -->
          </div>
          <div class="sp-el-form-ignite">
            <ConfigDetailIgnite v-for="(item,index) of igniteList" :key="item.itemKey" ref="configDetailIgniteRef" :index="index" :itemKey="item.itemKey" :baseConfig="baseConfig" :treeData="treeData"
              @handleConnect="handleIgniteConnect" :levelIndex="levelIndex" @handleSelectIgnite="handleSelectIgnite" @handleDeleteIgnite="handleDeleteIgnite" :saveInfo="item.saveInfo"
              :saveKey="iginteSaveKeyObj[item.itemKey]"
            />
            <div class="operate-style" @click="addIgniteCount()" v-if="!isRegion">+ 添加售点规则限制</div>
            <div class="warning" v-if="(!isRegion&&igniteError)">请添加售点规则限制（可用区域、规则限制均不可为空）！</div>
          </div>
        </div>
        <!-- <el-form-item  label-width="180px" v-model="params.title" prop="title" :label="getAssignName">
        </el-form-item> -->
        <!-- <el-form-item :label="getAssignName" prop="isAssign" v-model="params.title"> 
            <div class="display_flex" v-if="getSubAssignList.length!==0">
              <ConfigDetailAssign ref="ConfigDetailAssignRef" @handleSubmit="handleSubmit" class="assign_item" v-for="item of getSubAssignList" :assignAreaList="assignAreaList"
              :key="item.orgCode" :saveSubAssignList="saveSubAssignList" :assignItem="item" :assignBuList="assignBuList"></ConfigDetailAssign>
            </div>
            <div v-else class="tip">
              暂无可分配对象，请在城市池添加数据后再分配！
            </div>
            <div v-show="showError" class="warning">请分配额度！</div>
        </el-form-item> -->

        <el-form-item class="input-width-sp" v-if="params.needTransitions==0" :label="`每${getUnits}执行活动天数`" prop="perExecDays" ref="perExecDaysRef">
          <el-input type="number" :min="1" v-model="params.perExecDays" placeholder="请输入活动天数"></el-input>
        </el-form-item>
        <el-form-item class="input-width-sp" v-else label="道具数量设置" prop="itemQuantity" ref="itemQuantityRef">
          <el-input type="number" :min="1" v-model="params.itemQuantity" placeholder="请设置道具数量"></el-input>
        </el-form-item>

        <div class="sp_form_box">
          <div class="sp_item_title"><span style="color:red">* </span>{{getAssignName}}</div>
          <div class="sp-el-form-assign">
            <!-- <el-radio-group class="item" v-model="params.needTransitions" @input="handleTransitionsChange" v-if="getLevelIndex===0">
              <el-radio :label="0">不需要转场</el-radio>
              <el-radio :label="1">需要转场</el-radio>
            </el-radio-group> -->
            <div v-for="(item,index) of submitAssignList" class="el-form-assign-item" :key="item.assignItemKey+index" >
              <div class="display_flex" v-if="getSubAssignList.length!==0">
                <ConfigDetailAssignTransition ref="ConfigDetailAssignTransition" @handleSubmit="handleSubmit" :itemKey="item.assignItemKey" :getSubAssignList="getSubAssignList" class="assign_item" :assignAreaList="assignAreaList"
                :saveSubAssignList="item.subAssignList" :assignItemInfo="item" :assignBuList="assignBuList" :needTransitions="0" @handleSubmitAssign="handleSubmitAssign"
                @handleDeleteAssign="handleDeleteAssign" @handleChangeAssignDate="handleChangeAssignDate" :levelIndex="levelIndex" :pickerOptions="pickerOptions" :submitAssignList="submitAssignList"/>
                <!-- <ConfigDetailAssign ref="ConfigDetailAssignRef" @handleSubmit="handleSubmit" class="assign_item" v-for="item of getSubAssignList" :assignAreaList="assignAreaList"
                :key="item.orgCode" :saveSubAssignList="saveSubAssignList" :assignItem="item" :assignBuList="assignBuList"></ConfigDetailAssign> -->
              </div>
              <!-- <div v-else class="tip">
                暂无可分配对象，请在城市池添加数据后再分配！
              </div> -->
              <div v-show="showError" class="warning">请分配额度！</div>
            </div>
            <!-- <div class="warning" v-if="(submitAssignList.length===0&&getLevelIndex!==0)">请在该活动形式的首个级别添加转场时间！</div> -->
            <!-- <div v-if="params.needTransitions===1" class="add-date-box">
              <div @click="handleAddDate" class="operate-style operate-style-margin" v-if="getLevelIndex===0">+ 添加执行时间段</div>
              <el-date-picker
                v-show="isAddDate"
                :picker-options="pickerOptions"
                v-model="value1"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleSelectDate">
              </el-date-picker>
            </div> -->
            <div class="warning" v-if="assignError">不可选择相同的转场时间！</div>
            <div class="units-tip">活动额度基于{{getUnitsTip()}}进行分配</div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
// import ConfigDetailBu from './config-detail-assign.vue'
import { mapGetters,mapState } from 'vuex'
import ConfigDetailAssignTransition from './config-detail-assign-transition.vue'
import ConfigDetailIgnite from './config-detail-ignite.vue';
import { getDateFromString } from '@/filters'
export default {
  components:{
    ConfigDetailAssignTransition,
    ConfigDetailIgnite
},
  props: {
    themeStyles1: {
      type: Object,
      default: () => { }
    },
    baseConfig: {
      type: Object,
      default: () => { }
    },
    secondTabItemName: {
      type: String,
      default: ''
    },
    fullConfig: { type: Array, default: () => [] },
    assignBuList: { type: Array, default: () => [] },
    saveDetailList: { type: Object, default: () => { } },
    styleInfo:{ type: Object, default: () => { } },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    levelIndex:{type:String,default:'0'},
    styleAssignList:{ type: Array, default: () => [] },
    needTransitions:{type:Number,default:1},
  },
  data() {
    var validatePocCountMin = (rule, value, callback) => {
      if(Number(value)<1){
        return callback(new Error('最小售点数需大于等于1'));
      }else {
        callback()
      }
    };
    return {
      hidden: false,
      radio: '',
      params: {
        needVerify: 1,
        needConstruct: 1,
        needSpr: 1,
        needSupervisor: 1,
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        igniteStatus:[],
        openStatus:[],
        channel:[],
        bizForm:[],
        pocGrade:[],
        salesVolume:[],
        igniteRuleObj: {
          igniteStatus:[],
        },
        isAssign:'',
        needTransitions:1,
        title:'1',
        itemQuantity:'',
        perExecDays:''
      },
      themeDetail:{},
      igniteRuleObj: {
        igniteStatus:['01'],
      },
      editRules: {
        needVerify: [{ required: true, message: '请选择是否需要场勘', trigger: 'change' }],
        needConstruct: [{ required: true, message: '请选择是否需要搭建', trigger: 'change' }],
        needSpr: [{ required: true, message: '请选择是否需要Spr', trigger: 'change' }],
        // needSupervisor: [{ required: true, message: '请选择是否需要督导打卡', trigger: 'change' }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
        pocCountMin: [{ validator:validatePocCountMin, trigger: "blur" },
                        { required: true, message: "请输入售点数量"}],
        // igniteStatus: [{ required: true, message: "请选择IGNITE状态"}],
        // openStatus: [{ required: true, message: "请选择售点状态", trigger: "change" }],
        // channel: [{ required: true, message: "请选择渠道设置", trigger: "change" }],
        // bizForm: [{ required: true, message: "请选择业态", trigger: "change" }],
        // pocGrade: [{ required: true, message: "请选择档次", trigger: "change" }],
        // salesVolume: [{ required: true, message: "请选择销售潜力", trigger: "change" }],
        title: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
        region: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
        isAssign:[{required: true, message: '请选择分配额度', trigger: 'change' }],
        itemQuantity: [{ required: true, message: '请设置道具数量', trigger: 'blur' }],
        perExecDays:[{required: true, message: '请输入活动天数', trigger: 'blur' }]
      },
      radioList: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      assignBu:[],
      showDecorates:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      saveSubAssignList:[],
      themeConfig:{},
      employeeLevel:'',
      props: { multiple: true },
      showError:false,
      btnType:'',
      igniteCount:0,
      igniteList:[],
      //cityPoolList:[],
      cityPoolListValid:[],
      selectedList:[],
      isAddDate:false,
      value1:[],
      submitAssignList:[],
      pickerOptions: {
        disabledDate:time=>{return time.getTime() < this.themeStartTime || time.getTime() > this.themeEndTime}
      },
      submitItem:{},
      showSaveAssignList:false,
      styleAssignDateList:[],
      igniteError:false,
      assignError:false,
      treeData:[],
      iginteSaveKeyObj:{}
    }
  },
  watch: {
    'styleAssignList':{
      handler:function(cur){
        // console.log(this.levelIndex);
        // if(this.getLevelIndex!=0&&!this.showSaveAssignList){
        //   this.submitAssignList = cur.map(item=>{
        //     return item
        //   })
        // }
      },
      immediate:true,
      deep:true,
    },
    // 'needTransitions':{
    //   handler:function(cur){
    //     console.log('watch',this.needTransitions);
    //     if(this.getLevelIndex!==0){
    //       this.params.needTransitions = cur
    //     }
    //   },
    //   immediate:true,
    // },
    // 有等级的情况下，转场设置一致（暂时不需要）
    // 'levelIndex':{
    //   handler:function(cur,old){
    //     console.log('watch',this.levelIndex,cur,old);
    //     if(old&&old[0]=='0'){
    //       this.handleTransitionsChange(1)
    //     }
    //   },
    //   immediate:true,
    // },
    // 'themeStartTime':{
    //   handler:function(cur,old){
    //     console.log('watch:themeStartTime');
    //     if(this.getLevelIndex==0&&this.params.needTransitions!==0){
    //       this.handleTransitionsChange()
    //     }
    //   },
    //   immediate:true,
    // },
    // 'themeEndTime':{
    //   handler:function(cur,old){
    //     console.log('watch:themeEndTime');
    //     if(this.getLevelIndex==0&&this.params.needTransitions!==0){
    //       this.handleTransitionsChange()
    //     }
    //   },
    //   immediate:true,
    // }
  },
  computed:{
     ...mapGetters(['userInfo']),
     ...mapState({
      cityPoolList: state => state.gameplan.cityPoolList,
      themeStartTime: state => state.gameplan.themeStartTime,
      themeEndTime: state => state.gameplan.themeEndTime,
    }),
     pocRelateTypeDesc () {
      //console.log(this.themeConfig.pocRelateType)
      if (this.themeConfig.pocRelateType === 0) {
        return '当前活动形式无需执行售点'
      } else if (this.themeConfig.pocRelateType === 1) {
        return '当前活动形式需要单售点执行'
      } else if (this.themeConfig.pocRelateType === 2) {
        return '当前活动形式需要多售点执行'
      } else {
        return ''
      }
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getAssignName(){
      if(this.isHQ){
        return 'BU额度配置'
      }else if(this.isBU){
        return '销售大区额度配置'
      }else {
        return '城市额度配置'
      }
    },
    getSubAssignList(){
      if(this.isHQ){
        return this.assignBuList
      }else if(this.isBU){
        return this.assignRegionList
      }else {
        return this.assignAreaList
      }
    },
    getLevelIndex(){
      return Number(this.levelIndex[0])
    },
    getUnits(){
      let key = this.themeConfig.pocRelateType+''
      let units = '街区'
      switch (key) {
        case '0':
          units = '活动地点'
          break;
          case '1':
          units = '售点'
          break;
        default:
        units = '街区'
          break;
      }
      return units
    }
  },
  created() {
    //JSON.parse(JSON.stringify(this.cityPoolList));
    // let igniteInitData = JSON.parse(JSON.stringify(this.initData2))
    // console.log(igniteInitData);
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeStyles = {...this.themeStyles1}
    let mandatoryDecorates =[]
    this.showDecorates = []
    this.cityPoolListValid =  JSON.parse(JSON.stringify(this.cityPoolList));
    this.handleDataToTree()
    // console.log(this.themeStyles);
    // console.log("themeStyles",this.themeStyles);
    // console.log("baseConfig",this.baseConfig);
    // console.log("fullConfig",this.fullConfig);
    // console.log("assignBuList",this.assignBuList);
    // console.log("saveDetailList",this.saveDetailList);
    // console.log("styleInfo",this.styleInfo);
    if(Object.keys(this.saveDetailList).length !== 0 && !this.saveDetailList.isEmpty){
      let saveThemeDetail
      if(this.saveDetailList.themeDetail){
        saveThemeDetail = this.saveDetailList.themeDetail || this.saveDetailList
      }else {
        saveThemeDetail = this.saveDetailList
      }
      //console.log(this.saveDetailList);
      if(saveThemeDetail && (saveThemeDetail.themeStyleCode === this.themeStyles1.themeStyleCode)){
        // this.params = {...this.themeStyles1, ...this.themeStyles1.igniteRuleObj}
        let themeDecorateCodes = []
        if(saveThemeDetail.themeDecorateCodes&&saveThemeDetail.themeDecorateCodes.length>0){
          themeDecorateCodes = Object.assign([],saveThemeDetail.themeDecorateCodes)
        }
        this.params = {...saveThemeDetail, ...saveThemeDetail.igniteRuleObj,themeDecorateCodes}
        this.params.isAssign = '1'
        let themeStyleCode = this.themeStyles1.themeStyleCode || ''
        let themeLevelCode = this.themeStyles1.themeLevelCode || ''
        //console.log(themeLevelCode);
        for(let themeConfig of this.baseConfig.themeStyles){
          if(themeConfig.themeStyleCode === themeStyleCode){
            //console.log(themeConfig.themeStyleCode);
            //console.log(themeStyleCode);
            if(themeLevelCode&&themeConfig.themeLevels){
              for(let i of themeConfig.themeLevels){
                if(themeLevelCode === i.themeLevelCode)
                this.themeConfig = i.themeConfig
              }
            }else{
              this.themeConfig = themeConfig.themeConfig
            }
          }
        }
        mandatoryDecorates = this.themeConfig.mandatoryDecorates ||  []
        this.showDecorates = Object.assign([],this.themeConfig.showDecorates)
        for(let i=0;i<this.showDecorates.length;i++){
          for(let mandatory of mandatoryDecorates){
            if(mandatory.decorateCode===this.showDecorates[i].decorateCode){
              this.showDecorates[i].mandatory = true
            }
          }
        }
        // 获取ignite数据
        let igniteInitData = this.saveDetailList.igniteRuleDTOList
        if(igniteInitData&&igniteInitData.length>0){
          this.igniteCount = igniteInitData.length
          if(this.isHQ||this.isBU){
            this.iginteSaveKeyObj = {}
            this.igniteList = igniteInitData.map((item,index)=>{
              item.itemKey = index+1
              let igniteMappingDTOList = []
              if(item.igniteMappingDTOList){
                let data = []
                item.igniteMappingDTOList.forEach(selectedItem=>{
                  let buItem = {
                    buCode:selectedItem.buCode,
                    regionCode:selectedItem.regionCode
                  }
                  igniteMappingDTOList.push(buItem)
                  let treeItem = {
                    id:selectedItem.regionCode
                  }
                  if(this.isHQ){
                    treeItem.parent=selectedItem.buCode
                  }
                  this.handleIgniteDataChange(treeItem,item.itemKey)
                  if(!selectedItem.regionCode){
                    this.selectedList.push(selectedItem.buCode)
                  }
                  data.push(selectedItem.regionCode)
                })
                this.iginteSaveKeyObj[item.itemKey]=data
              }
              let saveInfo = Object.assign({},item)
              let curItem = {
                igniteMappingDTOList:igniteMappingDTOList,
                igniteRuleObj:item.igniteRuleObj,
                saveInfo,
                itemKey:item.itemKey
              }
              return curItem
            })
          }else if(this.isRegion){
            this.igniteList = igniteInitData.map((item,index)=>{
              //console.log(item.igniteBuList);
              item.itemKey = index+1
              let igniteMappingDTOList = []
              item.igniteMappingDTOList.map(selectedItem=>{
                let buItem = {
                  buCode:selectedItem.buCode,
                  regionCode:selectedItem.regionCode
                }
                igniteMappingDTOList.push(buItem)
                this.cityPoolListValid = []
              })
              let saveInfo = Object.assign({},item)
              let curItem = {
                igniteMappingDTOList:igniteMappingDTOList,
                igniteRuleObj:item.igniteRuleObj,
                saveInfo,
                itemKey:item.itemKey
                //Object.assign({},item.igniteBuList,item.igniteRuleObj,saveInfo)
              }
              //console.log(curItem);
              return curItem
            })
          }
        }
        // 获取配置数据
        if(this.saveDetailList.subAssignMap){
          //console.log(this.saveDetailList.subAssignMap);
          let assignItemKey = 1
          //let keyList = Object.keys()
          for(let key in this.saveDetailList.subAssignMap){
            //console.log(key);
            let dateList = key.split('至')
            let data = {
              assignStartTime:getDateFromString(dateList[0]),
              assignEndTime:getDateFromString(dateList[1]),
              assignItemKey,
              needTransitions:1,
              subAssignList:this.saveDetailList.subAssignMap[key]
            }
            //console.log(data);
            this.submitAssignList.splice(this.submitAssignList.length,0,data)
            //console.log(this.submitAssignList);
            assignItemKey++
          }
          // 初始化相同活动形式的配置信息
          if(this.getLevelIndex==0){
            this.$emit("handleStyleAssignChange",'init',this.submitAssignList,this.params.needTransitions)
          }
        }else {
          if(this.styleAssignList&&this.styleAssignList.length>0){
            if(this.levelIndex!==0){
              this.submitAssignList = this.styleAssignList.map(item=>{
                item.index = this.getLevelIndex
                return item
              })
              this.params.needTransitions = this.needTransitions
            }
          }else {
            //console.log(this.saveDetailList.themeDetail.needTransitions);
           this.handleTransitionsChange(this.saveDetailList.themeDetail.needTransitions)
          }
        }
      }
      // 草稿中 业态+子业态的展示( 子业态需求改了，暂时不用 )
      // if(saveThemeDetail.igniteRuleObj.subBizForm){
      //   this.params.bizForm = saveThemeDetail.igniteRuleObj.subBizForm.map((item)=>{
      //     let data = [item.split('-')[0],item]
      //     return data
      //   })
      // }
    }else {
      this.themeConfig = this.themeStyles.themeConfig
      mandatoryDecorates = this.themeStyles.themeConfig.mandatoryDecorates || []
      this.showDecorates = Object.assign([],this.themeConfig.showDecorates)
      //this.showDecorates = this.themeStyles.themeConfig.showDecorates || []
      for(let i=0;i< this.showDecorates.length;i++){
        for(let mandatory of mandatoryDecorates){
          if(mandatory.decorateCode===this.showDecorates[i].decorateCode){
            this.params.themeDecorateCodes.push(this.showDecorates[i].decorateCode)
            this.showDecorates[i].mandatory = true
          }
        }
      }
      // this.params.needTransitions = 0
      // this.handleTransitionsChange(0)
      // 新加的等级，转场信息要与前面等级的转场信息一样
      if(this.getLevelIndex==0){
        this.params.needTransitions = 0
        this.handleTransitionsChange(1)
        this.$emit("handleStyleAssignChange",'change',this.submitAssignList,this.params.needTransitions)
      }else if(this.styleAssignList&&this.styleAssignList.length>0){
        //if(this.levelIndex!==0){
          this.params.needTransitions = this.needTransitions
          this.submitAssignList = this.styleAssignList.map(item=>{
            item.index = this.getLevelIndex
            return item
          })
        //}
      }else {
        this.handleTransitionsChange(1)
      }
    }
    this.saveSubAssignList = this.saveDetailList.subAssignList || []
    // console.log('this.showDecorates',this.showDecorates);
    // console.log('this.saveSubAssignList',this.saveSubAssignList);
    // console.log(this.themeDetail);
    //this.cityPoolListValid = Object.assign([],this.cityPoolList)
  },
  mounted(){
    this.$refs.editFormRef.resetFields()
    if(this.isRegion&&this.igniteList.length===0){
      this.addIgniteCount()
    }
    this.$nextTick(() => {
      this.processSpecialDecorateCtl()
      //this.handleTransitionsChange()
    })
  },
  methods: {
    // 获取业态、子业态 级联数据（子业态需求改了，暂时不用）
    // getBizForm(){
    //   let subBizForm = []
    //   for(let key in this.igniteOptions.subBizForm){
    //     let obj = null
    //     obj = {
    //       bizForm:key.split('-')[0],
    //       value:key,
    //       label:this.igniteOptions.subBizForm[key],
    //     }
    //     subBizForm.push(obj)
    //   }
    //   let subBizFormList = []
    //   subBizForm.forEach(item => {
    //     let flag = subBizFormList.find(item1 => item1.bizForm === item.bizForm)
    //     if (!flag) {
    //       subBizFormList.push({
    //         bizForm: item.bizForm,
    //         children: [item]
    //       })
    //     } else {
    //       flag.children.push(item)
    //     }
    //   })
    //   let bizFormList = subBizFormList.map((item)=>{
    //     item.value = item.bizForm
    //     item.label = this.igniteOptions.bizForm[item.bizForm]
    //     return item
    //   })
    //   return bizFormList
    // },
    getBizForm(){
      switch (this.baseConfig.themeChannelCode) {
        case '01':
          return {'2022010103': "大排档",'2022010104': "火锅",'2022010105': "烧烤/小龙虾",'2022010106':"中式正餐",'2022010201': "夜总会",'2022010202': "KTV",'2022010203': "慢摇吧",'2022010204': "酒吧",'2022010205': "餐吧"}
        case '02':
          return {'2022010103': "大排档",'2022010104': "火锅",'2022010105': "烧烤/小龙虾",'2022010106':"中式正餐"}
        case '03':
          return {'2022010203': "慢摇吧"}
        case '04':
          return {'2022010201': "夜总会",'2022010202': "KTV"}
        case '05':
          return {'2022010204': "酒吧",'2022010205': "餐吧"}
        case '06':
          return {'2022010204': "酒吧",'2022010205': "餐吧"}
        default:
          return {}
      }
    },
    getUnitsTip(){
      let units = '街区'
      let needTransitionsStr = ''
      if(this.params.needTransitions===1){
        needTransitionsStr = '/天'
      }
      if(this.themeConfig.pocRelateType===1){
        units = '售点'
      }else if (this.themeConfig.pocRelateType===0){
        units = '活动地点'
      }
      return `${units}${needTransitionsStr}`
    },
    handleSubmitAssign(subAssignItem,assignItemKey){
        let index =this.submitAssignList.findIndex(item=>{
          return item.assignItemKey === assignItemKey
        })
        if(index===-1){
          console.log("发现了问题！！");
          //this.submitAssignList.subAssignList.push(subAssignItem)
        }else {
          this.submitAssignList[index].subAssignList = subAssignItem
        }
    },
    handleChangeAssignDate(data,assignItemKey){
      //console.log(assignItemKey);
      let index = this.findIndex(this.submitAssignList,assignItemKey)
      //console.log(this.submitAssignList[index]);
      this.submitAssignList[index].assignStartTime=data[0]
      this.submitAssignList[index].assignEndTime=data[1]
      //console.log(222,this.levelIndex);
      //this.$emit("handleStyleAssignChange",'date',data,assignItemKey)
      if(this.getLevelIndex==0&&!this.showSaveAssignList){
        //console.log(222,this.levelIndex);
        this.$emit("handleStyleAssignChange",'date',this.submitAssignList,data,assignItemKey)
      }
      // this.$emit("handleStyleAssignChange",this.submitAssignList)
    },
    handleDeleteAssign(assignItemKey){
      let index =this.findIndex(this.submitAssignList,assignItemKey)
      this.submitAssignList.splice(index,1)
      if(this.getLevelIndex==0){
        this.$emit("handleStyleAssignChange",'init',this.submitAssignList,this.params.needTransitions)
        this.$emit("handleStyleAssignChange",'delete',this.submitAssignList,assignItemKey)
      }
    },
    findIndex(list,itemKey){
      let index =list.findIndex(item=>{
        return item.assignItemKey === itemKey
      })
      if(index===-1){
        console.log("发现了问题");
      }
      return index
    },
    processSpecialDecorateCtl() {
      //console.log('processSpecialDecorateCtl')
      // 人工照片类型20需要特殊处理，当需要搭建为1时，强制必选
      const decorateWorkPhoto = '20'
      const decorateIndex = this.showDecorates.findIndex(item => {
        return item.decorateCode === decorateWorkPhoto
      })
      //console.log(decorateIndex)
      if (decorateIndex > -1) {
        const decorateObj = this.showDecorates[decorateIndex]
        decorateObj.mandatory = this.params.needConstruct === 1
        this.showDecorates.splice(decorateIndex, 1, decorateObj)
        if (this.params.needConstruct === 1) {
          if (this.params.themeDecorateCodes.indexOf(decorateWorkPhoto) < 0) {
            this.params.themeDecorateCodes.push(decorateWorkPhoto)
          }
        }else {
          let index = this.params.themeDecorateCodes.indexOf(decorateWorkPhoto)
          if( index > -1 ) {
            this.params.themeDecorateCodes.splice(index,1)
          } 
        } 
      }
    },
    onNeedConstructChanged() {
      this.processSpecialDecorateCtl()
    },
    needTransitionsChanged(){
      if(this.params.needTransitions===0){
        this.$refs.perExecDaysRef.resetField()
      }else {
        this.$refs.itemQuantityRef.resetField()
      }
      this.params.perExecDays = ''
      this.params.itemQuantity = ''
    },
    // ignite相关处理
    // 初始化传入给ignite组件的数据，转换为el-tree可用的数据形式
    handleDataToTree(){
      this.cityPoolList.forEach(firstInfo=>{
        let firstId = this.isHQ?firstInfo.buCode:firstInfo.regionCode
        let first = {
          label:this.getName(firstInfo.buName)||this.getName(firstInfo.regionName),
          id:firstId
        }
        if(firstInfo.regionList&&firstInfo.regionList.length>0){
          first.children = []
          firstInfo.regionList.forEach(secondInfo=>{
            let second= {
              label:this.getName(secondInfo.regionName),
              id:secondInfo.regionCode,
              parent:firstInfo.buCode,
              selected:'',
            }
            first.children.push(second)
          })
        }else {
          first.selected = ''
          if(this.isBU){
            first.parent=firstInfo.buCode
          }
        }
        this.treeData.push(first)
      })
    },
    // 添加售点规则限制
    addIgniteCount(){
      this.igniteError = false
      this.igniteCount++
      let data = {
        igniteMappingDTOList:[],
        igniteRuleObj:{
          igniteStatus:[],
          openStatus:[],
          channel:[],
          bizForm:[],
          pocGrade:[],
          salesVolume:[],
        },
        // id:this.igniteList
      }
      if(this.isRegion){
        let item = {buCode:this.userInfo.buCode,regionCode:this.userInfo.regionCode}
        data.igniteMappingDTOList.push(item)
      }
      data.itemKey = (this.igniteList.length===0 ? this.igniteCount : this.igniteList[this.igniteList.length-1].itemKey+1)
      //this.igniteList.length===0?data.itemKey = this.igniteCount:data.itemKey=this.igniteList[this.igniteList.length-1].itemKey+1
      this.igniteList.push(data)
    },
    // 删除售点规则限制
    handleDeleteIgnite(data,itemKey){
      if(this.isHQ||this.isBU){
        for(let deleteItem of data){
          this.handleIgniteDataChange(deleteItem,itemKey,true)
        }
      }
      this.igniteList.map((item,index)=>{
        if(item.itemKey===itemKey){
          this.igniteList.splice(index,1)
        }
      })
    },
    // ignite规则内容的修改
    handleSelectIgnite(type,data,id){
      this.igniteList.map(item=>{
        if(item.itemKey===id){
          item.igniteRuleObj[type] = data
        }
      })
    },
    // 点击el-tree时修改数据
    handleIgniteConnect(data,itemKey,isClear,isParent){
      // 点击ignite地区选择框时修改节点的selected状态
      this.handleIgniteDataChange(data,itemKey,isClear)
      // 根据修改的内容保存要提交的信息
      this.igniteList.map(item=>{
        if(item.itemKey===itemKey){
          if(isParent){
            item.igniteMappingDTOList = item.igniteMappingDTOList.filter(mappingItem=>{
              return mappingItem.buCode!==data.id
            })
            item.igniteMappingDTOList = item.igniteMappingDTOList.filter(buItem=>{
              let saveItem = true
              if(buItem.buCode===data.id){
                saveItem=false
              }
              return saveItem
            })
            if(!isClear){
              let allRegionList = []
              data.children.forEach(region=>{
                if(region.selected===itemKey){
                  let item = {
                    buCode:data.id,
                    regionCode:region.id
                  }
                  allRegionList.push(item)
                }
              })
              item.igniteMappingDTOList = item.igniteMappingDTOList.concat(allRegionList)
            }
          }else {
            // 是子节点
            if(!isClear){
              let addItem = {
                buCode:data.parent,
                regionCode:data.id
              }
              item.igniteMappingDTOList.push(addItem)
            }else {
              item.igniteMappingDTOList = item.igniteMappingDTOList.filter(mappingItem=>{
                return mappingItem.regionCode!==data.id
              })
            }
          }
        }
        return item
      })
    },
    // ignite配置可用区域 删除/修改通用函数
    handleIgniteDataChange(data,itemKey,isClear){
      for(let item of this.treeData){
        if(data.children&&data.children.length>0){
          // 点击的节点有子节点
          if(data.id === item.id){
            for(let regionItem of item.children){
              //将子节点中没有被其他规则选中的region全选或者全不选
              if(regionItem.selected===''||regionItem.selected===itemKey){
                regionItem.selected = isClear?'':itemKey
              }
            }
          }
        }else if(data.parent&&this.isHQ){
          // 点击的节点有父节点
          if(data.parent === item.id){
            for(let regionItem of item.children){
              if(regionItem.id == data.id){
                regionItem.selected = isClear?'':itemKey
              }
            }
          }
        }else {
          // 点击的节点既无父节点也无子节点
          if(data.id === item.id){
            item.selected = isClear?'':itemKey
          }
        }
      }
      if(this.$refs.configDetailIgniteRef){
        for(let item of this.$refs.configDetailIgniteRef){
          item.setSelectedStatus()
          //item.$refs.tree.filter()
        }
      }
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    handleSubmit(subAssignItem){
      this.subAssignList.push(subAssignItem)
      if(this.subAssignList.length===this.assignBuList.length){
        let error = true
        for(let item of this.subAssignList){
          //console.log(item);
          if(item.assignQty){
            error = false
          }
        }
        if(this.btnType==='submit'){
          this.showError = error
        }
      }
      this.params.isAssign = true
      //console.log(themeDetail);
    },
    submit(type) {
      this.btnType = type
      //this.subAssignList = []
      //this.params.isAssign = ''
      //console.log(this.$refs.ConfigDetailAssignRef);
      if(this.$refs.ConfigDetailAssignRef&&this.$refs.ConfigDetailAssignRef.length&&this.$refs.ConfigDetailAssignRef.length>0){
        for(let i=0;i<this.$refs.ConfigDetailAssignRef.length;i++){
          this.$refs.ConfigDetailAssignRef[i].submit()
        }
      }
      if(type==='submit'){
        // 判断ignite填写是否满足要求的校验
        if(this.themeConfig.pocRelateType === 1 || this.themeConfig.pocRelateType === 2){
          if(this.igniteList.length===0){
            //this.showIgniteError = true
            //this.params.title = ''
            this.igniteError = true
            this.$emit("handleSubmit",{},false)
            return
          }else {
            for(let igniteItem of this.igniteList){
              if(igniteItem.igniteMappingDTOList.length===0){
                this.igniteError = true
                this.$emit("handleSubmit",{},false)
                return
              }
              let haveRules = false
              //console.log(igniteItem.igniteRuleObj);
              for(let ruleKey in igniteItem.igniteRuleObj){
                if(igniteItem.igniteRuleObj[ruleKey]&&igniteItem.igniteRuleObj[ruleKey].length!==0){
                  haveRules = true
                }
              }
              if(!haveRules){
                this.igniteError = true
                this.$emit("handleSubmit",{},false)
                return
              }
            }
          }
        }
        this.igniteError = false
        this.validateSubmit()
        // this.submitData()
      }else{
        this.$refs.editFormRef.clearValidate()
        this.submitData()
      }
    },
    submitData(){
      for(let i=0;i<this.assignBuList.length;i++){
        let detail = this.assignBuList[i]
        let item = {
          orgName:detail.orgName,
          orgCode:detail.orgCode,
          assignQty:this.assignBu[i]
        }
        //this.subAssignList.push(item)
      }
      //console.log(this.baseConfig);
      // this.subAssignList.push(this.subAssignItem)
      this.themeDetail.needVerify = this.params.needVerify
      this.themeDetail.needConstruct = this.params.needConstruct
      this.themeDetail.needSpr = this.params.needSpr
      this.themeDetail.needSupervisor = this.params.needSupervisor
      this.themeDetail.themeDecorateCodes = this.params.themeDecorateCodes
      this.themeConfig.pocRelateType === 2 ? this.themeDetail.pocCountMin = this.params.pocCountMin : this.themeDetail.pocCountMin = this.themeConfig.pocRelateType
      this.themeDetail.pocRelateType = this.themeConfig.pocRelateType
      // 业态与子业态 （需求改变，暂时不需要）
      // let bizForm =  this.params.bizForm.reduce((pre,item)=>{
      //   if(pre.indexOf(item[0])===-1){
      //     pre.push(item[0])
      //     return pre
      //   }else return pre
      // },[])
      // let subBizForm =  this.params.bizForm.reduce((pre,item)=>{
      //   if(pre.indexOf(item[1])===-1){
      //     pre.push(item[1])
      //     return pre
      //   }else return pre
      // },[])
      let igniteRuleObj ={igniteStatus:this.params.igniteStatus,
        openStatus:this.params.openStatus,
        channel:this.params.channel,
        bizForm:this.params.bizForm,
        // subBizForm:subBizForm,
        pocGrade:this.params.pocGrade,
        salesVolume:this.params.salesVolume}
      //this.themeDetail.igniteRuleObj = igniteRuleObj
      this.themeDetail.themeChannelCode = this.baseConfig.themeChannelCode
      this.themeDetail.themeStyleCode = this.styleInfo.themeStyleCode || this.themeStyles.themeStyleCode || ''
      if(this.secondTabItemName){
        this.themeDetail.themeLevelCode = this.themeStyles1.themeLevelCode || ''
        this.themeDetail.nextLevelRate = this.themeStyles1.nextLevelRate || ''
        this.themeDetail.nextLevelCode = this.themeStyles1.nextLevelCode || ''
        this.themeDetail.isLast = this.themeStyles1.isLast
      }
      this.themeDetail.needTransitions = this.params.needTransitions
      this.themeDetail.itemQuantity = this.params.itemQuantity
      this.themeDetail.perExecDays = this.params.perExecDays
      this.submitItem.themeDetail = this.themeDetail
      this.submitItem.igniteRuleDTOList = this.igniteList
      //console.log(this.subAssignList);
      let submitAssignList = this.submitAssignList.map(session=>{
        session.subAssignList = session.subAssignList.map(buItem=>{
          if(this.params.needTransitions===0){
            buItem.assignStartTime = this.themeStartTime
            buItem.assignEndTime = this.themeEndTime
          }else {
            buItem.assignStartTime = session.assignStartTime
            buItem.assignEndTime = session.assignEndTime
          }
          return buItem
        })
        return session
      })
      let subAssignList = submitAssignList.reduce((pre,cur)=>{
        return pre.concat(cur.subAssignList)
      },[])
      this.submitItem.subAssignList = subAssignList
      //console.log(this.submitItem);
      this.$emit("handleSubmit",this.submitItem,true)
    },
    validateSubmit() {
      this.showError?this.$emit("handleSubmit",null,false):''
      this.$refs.editFormRef.validate(valid=>{
        if(valid){
          this.submitData()
        }else {
          let data = {}
          this.$emit("handleSubmit",null,false)
        }
      })
    },
    handleAddDate(){
      this.isAddDate = true
    },
    handleSelectDate(val){
      if(val.length!==0){
        for(let item of this.submitAssignList){
          if(item.assignStartTime==val[0]&&item.assignEndTime==val[1]){
            this.$alert(`不能选择相同时间段的转场时间！`, '提示', {
              confirmButtonText: '确定',
              confirmButtonClass: 'btn-red',
            }).then(() => {
            })
            this.value1 = []
            return
          }
        }
        let assignItemKey
        if(this.submitAssignList.length === 0){
          assignItemKey = 1
        }else {
          assignItemKey = this.submitAssignList[this.submitAssignList.length-1].assignItemKey + 1
        }
        let data = {
          assignStartTime:val[0],
          assignEndTime:val[1],
          assignItemKey,
          needTransitions:1,
          subAssignList:[]
        }
        this.submitAssignList.push(data)
        //console.log(this.showSaveAssignList);
        if(!this.showSaveAssignList&&this.getLevelIndex==0){
          this.$emit("handleStyleAssignChange",'init',this.submitAssignList,this.params.needTransitions)
          this.$emit("handleStyleAssignChange",'add',this.submitAssignList,val)
        }
        this.value1 = []
        this.isAddDate = false
      }
    },
    handleTransitionsChange(val,index){
      val?this.params.needTransitions=val:''
      //console.log(val);
      if(val===0||val===1){
        //console.log('this.params.needTransitions',val,0);
        this.submitAssignList = []
        let data = {
          //assignStartTime:this.value1[0],
          //assignEndTime:this.value1[1],
          assignItemKey:0,
          needTransitions:0,
          assignStartTime:this.themeStartTime,
          assignEndTime:this.themeEndTime,
          subAssignList:[]
        }
        this.submitAssignList.splice(0,0,data)
        //console.log(this.submitAssignList.length);
        if(!this.showSaveAssignList&&this.getLevelIndex==0){
          this.$emit("handleStyleAssignChange",'init',this.submitAssignList,this.params.needTransitions)
          this.getLevelIndex==0?this.$emit("handleStyleAssignChange",'change',this.submitAssignList,this.params.needTransitions):''
        }
      }else {
        //console.log('this.params.needTransitions',val,1);
        if(this.getLevelIndex!=0){
          this.submitAssignList = []
        }
        if(!this.showSaveAssignList){
          this.submitAssignList = []
          this.$emit("handleStyleAssignChange",'init',this.submitAssignList,this.params.needTransitions)
          this.getLevelIndex==0?this.$emit("handleStyleAssignChange",'change',this.submitAssignList,this.params.needTransitions):''
        }
      }
      //console.log(this.submitAssignList);
      this.showSaveAssignList = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom:8px;

  .el-form-item__label {
    color: black;
    font-weight: 600;
    margin-left:3px;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .el-input__inner {
  width: 155px !important;
}
::v-deep .input-width-sp .el-input__inner {
  width: 155px;
}
// ::v-deep .ignite_item_select .el-form-item__content {
//   width: calc(100% - 180px);
// }
// ::v-deep .ignite_item_select .el-select {
//   margin: 0 20px 10px 0;
// }
// ::v-deep .el-input__inner{
//   height: 36px;
//   line-height: 36px;
// }
::v-deep .ignite_item_select .el-form-item__content {
  width: calc(100% - 180px);
}
::v-deep .ignite_item_select .el-select {
  margin: 0 20px 10px 0;
}
::v-deep .el-select {
  margin: 0 20px 20px 0;
}
.select_item_red {
  height: 40px;
  line-height: 40px;
  width: 400px;

  ::v-deep .el-form-item__label {
    color: #e70027 !important;
    font-weight: bold;
  }
}
.infoBox_cross_line_box {
  margin: 0px 0 20px 0;
  font-weight: 600;
  color: rgb(182, 182, 182);
  .infoBox_cross_line{
    width:800px;
    height: 1px;
    background-color: rgb(238, 238, 238);
    margin: -19px 0 0 120px;
  }
}
.display_block{
  display:block;
}
.el-form-item{
  width: 100%;
}
.display_flex{
  width: 860px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
.display_flex_region{
  width: 80%;
  display: flex;
}
.sp-el-form{
  width: 75%;
  position: relative;
  left: 180px;
  margin-top: -65px;
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item__error{
  width: 150px;
}


::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    margin-left: -10px;
}

// .ignite_item_select .el-select {
//     height: 40px;
// }
// ::v-deep .el-select__tags {
//   display: flex;
//   flex-wrap: nowrap !important;
//   height: 35px;
//   overflow: hidden;
// }
::v-deep .el-cascader__tags {
    height: 35px;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    position: absolute;
    top: 60%;
}
::v-deep .sp .el-checkbox__input.is-checked .el-checkbox__inner,.sp .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #b5b5b5 !important;
    border-color: #b5b5b5 !important;
}

::v-deep .sp .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #ffffff !important;
    color: #606266 !important;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266 !important;
}
.el-checkbox {
    margin-right: 20px;
    
}
.decorate-style{
  width: 750px;
  display:flex;
  flex-wrap: wrap;
}
.tip{
  color: #cd1231;
  font-weight: 600;
}
.units-tip{
  color: #cd1231;
  margin-left: 3px;
  //font-size: 12px;
}
.warning{
  margin-bottom:20px;
  color: red;
}
.operate-style{
  width: 200px;
  cursor: pointer;
  color: #cd1231;
  margin-bottom: 15px;
}
.operate-style-margin{
  margin-top:7px;
}
.el-form-assign-item{
  margin:5px 0 10px 0;
}
::v-deep .add-date-box .el-input__inner {
  width: 250px !important;
}
.sp_form_box{
  display: flex; 
  margin-top: 10px;
  min-height: 35px;
  .sp-el-form-ignite{
    min-width: 50px;
    width: 85%;
    position: relative;
    // left: 180px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .el-form-item{
      width: 260px !important;
      margin:15px 15px -2px 0;
    }
  }
  .sp-el-form-assign{
    min-width: 50px;
    width: 85%;
    position: relative;
    top: -25px;
    // left: 180px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .el-form-item{
      width: 360px !important;
      margin:15px 15px -2px 0;
    }
  }
  .sp_item_title{
    width: 190px;
    margin-left: -6px;
    font-weight: 600;
  }
}
.ignite-form-tip{
  color: #cd1231;
}
</style>
